module.exports = __webpack_public_path__ + "static/media/group-9@3x.c51a1aa7.png";